/**
 * src\registered\site-admin\components\Workflow-esg\domains\esg_taxonmy_trawler_model.js
 * 📊 TRAWLER MODEL
 * Represents the physical profile of a taxonomy column.
 */
export const createTrawlerRecord = (columnName) => ({
  ColumnName: columnName,
  UniqueValues: new Set(), // For calculating UniqueValueCount
  TotalOccurrences: 0,
  MinLength: Infinity,
  MaxLength: 0,
  UniqueValueCount: 0 // Finalized count for the RTF
});